import { render, staticRenderFns } from "./UnitsFormPage.vue?vue&type=template&id=6363fbce&scoped=true&"
import script from "./UnitsFormPage.vue?vue&type=script&lang=js&"
export * from "./UnitsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363fbce",
  null
  
)

export default component.exports